export const HIKE_DIFFICULTY_OPTIONS = [
  // HIK-1087: manual-only beginner rating; Calculated mode never produces it.
  'CouchToTrail',
  'Easy',
  'Moderate',
  'Hard',
  'Strenuous'
] as const

export type HikeDifficulty = (typeof HIKE_DIFFICULTY_OPTIONS)[number]
export type WireHikeDifficulty = HikeDifficulty | 'Challenging' | 'Difficult'

export const DEFAULT_HIKE_DIFFICULTY: HikeDifficulty = 'Moderate'

export const parseHikeDifficulty = (value?: string | null): HikeDifficulty | null => {
  const normalized = value?.trim().toLowerCase()
  if (normalized === 'challenging') return 'Hard'
  if (normalized === 'difficult') return 'Strenuous'
  if (normalized?.replace(/[\s_-]/g, '') === 'couchtotrail') return 'CouchToTrail'
  return HIKE_DIFFICULTY_OPTIONS.find((option) => option.toLowerCase() === normalized) ?? null
}

const HIKE_DIFFICULTY_LABELS: Record<HikeDifficulty, string> = {
  CouchToTrail: 'Couch to Trail',
  Easy: 'Easy',
  Moderate: 'Moderate',
  Hard: 'Hard',
  Strenuous: 'Strenuous'
}

export const formatHikeDifficulty = (value: HikeDifficulty | null): string | null =>
  value ? HIKE_DIFFICULTY_LABELS[value] : null

export const HIKE_DIFFICULTY_LIST_TEXT = 'Couch to Trail, Easy, Moderate, Hard, or Strenuous'

export type HikeDifficultyMode = 'Legacy' | 'Calculated' | 'Manual'

export const parseHikeDifficultyMode = (value?: string | null): HikeDifficultyMode | null => {
  const normalized = value?.trim().toLowerCase()
  if (normalized === 'legacy') return 'Legacy'
  if (normalized === 'calculated') return 'Calculated'
  if (normalized === 'manual') return 'Manual'
  return null
}

export type HikeDifficultyCalculation = {
  version: string
  formulaType?: 'OneDay' | 'TwoDay' | 'ThreeOrMoreDays' | null
  hikingDays: number
  averageDistanceKm?: number | null
  averageElevationGainMeters?: number | null
  longestDistanceKm?: number | null
  highestDayElevationGainMeters?: number | null
  highestPointMeters?: number | null
  averageDistancePoints?: number | null
  averageElevationGainPoints?: number | null
  longestDistancePoints?: number | null
  highestDayElevationGainPoints?: number | null
  highestPointPoints?: number | null
  totalScore?: number | null
}
